import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const MediaRemoveButton = styled.div`
  background-color: #444d58;
  color: white;
  width: 22px;
  height: 22px;
  font-size: 12px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 13px;
  right: 13px;
  cursor: pointer;
`

const MediaRemove = ({ removeMedia }) => (
  <MediaRemoveButton onClick={removeMedia} className='br-media-remove'>
    <i className='fa fa-close' />
  </MediaRemoveButton>
)

MediaRemove.propTypes = {
  removeMedia: PropTypes.func
}

export default MediaRemove



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/media/media-remove.js